import { useTranslate } from "react-admin"
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { Grid, Typography, Dialog, DialogContent, DialogTitle, Card, CardContent, CardHeader } from '@mui/material'
import { useState } from 'react'
import { FormDivider } from 'src/components/uiElements/fields/Divider'
import { numberFormatterWithDecimalAndThousand } from "src/helper/numberFormatterWithDecimalAndThousand"
const GDS = "GDS"

const Itinerary = ({ itinerary }) => {
  const translate = useTranslate()

  if (Array.isArray(itinerary) && itinerary) {
    return (
      <>
        {itinerary?.map((row, i) => (
          <Grid container spacing={2} key={i}>
            <ShowListElement sm={2} label={translate('ra.field.origin')} value={row?.origin} />
            <ShowListElement sm={2} label={translate('ra.field.destination')} value={row?.destination} />
            <ShowListElement
              sm={2}
              label={translate('ra.field.destination_type')}
              value={row?.type_destination}
            />
            <ShowListElement sm={2} label={translate('ra.field.airline')} value={row?.operating_airline} />
          </Grid>
        ))}
      </>
    )
  }
}

const RoundType = ({ prebooking }) => {
  return (
    <>
      <Itinerary itinerary={prebooking?.itinerary} />
    </>
  )
}

const Prebooking = ({ prebooking }) => {
  const translate = useTranslate()
  if (prebooking)
    return (
      <>
        <ShowListElement sm={2} label={translate('ra.field.currency')} value={prebooking?.currency} />
        <ShowListElement sm={2} label={translate('ra.field.type')} value={prebooking?.fare_supplier?.type} />
        {prebooking?.fare_supplier?.type == GDS && (
          <ShowListElement
            sm={2}
            label={translate('ra.field.source')}
            value={prebooking?.fare_supplier?.code}
          />
        )}
        <ShowListElement
          sm={2}
          label={translate('ra.field.checkin')}
          value={prebooking?.checkin}
          type={'date'}
        />
        <ShowListElement
          sm={2}
          label={translate('ra.field.checkout')}
          value={prebooking?.checkout}
          type={'date'}
        />
      </>
    )
}


const NumPaxes = ({ form_passengers }) => {
  const translate = useTranslate()



  const countTotalPassengers = (formPassengers) => {
    try {
      return Object.values(formPassengers)
        .filter(Array.isArray)
        .reduce((total, currentArray) => total + currentArray.length, 0)
    } catch (error) {
      return 0
    }
  }

  if (form_passengers)
    return (
      <ShowListElement
        sm={2}
        label={translate('ra.field.num_pax')}
        value={countTotalPassengers(form_passengers) || 0}
      />
    )

}

const Payment = ({ payment }) => {
  const translate = useTranslate()
  if (payment)
    return (
      <>
        <Grid container spacing={2}>
          <ShowListElement
            label={translate('ra.field.amount')}
            value={numberFormatterWithDecimalAndThousand(payment?.total_amount)}
            sm={2}
          />
          <ShowListElement
            label={translate('ra.field.pyment_attempts')}
            value={payment?.current_retry + 1}
            sm={2}
          />
        </Grid>
        <PaymentsData payments={payment?.payments} />
      </>
    )
}

const PaymentsData = ({ payments }) => {
  const translate = useTranslate()

  const retry = (row) => {
    try {
      const { retry: retryNumber, status } = row || {}
      const label = [Number.isInteger(retryNumber) ? retryNumber + 1 : null, status]
        .filter(Boolean)
        .join(' - ')
      return label || null
    } catch {
      return null
    }
  }

  const sortedPayments = Array.isArray(payments)
    ? [...payments].sort((a, b) => (a.retry || 0) - (b.retry || 0))
    : []

  if (Array.isArray(payments) && payments) {
    return (
      <>
        {sortedPayments?.map((row, i) => (
          <Grid container spacing={2} key={i}>
            <ShowListElement sm={2} label={translate('ra.field.status')} value={retry(row)} />
            <ShowListElement sm={2} label={translate('ra.field.card')} value={row?.credit_card_name} />
            <ShowListElement sm={2} label={translate('ra.field.bank')} value={row?.bank_name} />
            <ShowListElement sm={2} label={translate('ra.field.gateway')} value={row?.gateway} />
            <ShowListElement sm={2} label={translate('ra.field.quota')} value={row?.quotes} />
            <ShowListElement sm={2} label={translate('ra.field.payment_detail')} value={row?.message} />
          </Grid>
        ))}
      </>
    )
  }
}

const Promotions = ({ promotions }) => {
  const translate = useTranslate()
  if (Array.isArray(promotions) && promotions.length > 0) {
    return (
      <>
        {promotions?.map((promo, i) => (
          <Grid container spacing={2} key={i}>
            <ShowListElement 
              sm={2} 
              label={`${translate('ra.field.promo')} ${i + 1}`} 
              value={promo?.label} 
            />
            <ShowListElement 
              sm={2} 
              label={`${translate('ra.field.amount')} ${translate('ra.field.promo')} ${i + 1}`} 
              value={numberFormatterWithDecimalAndThousand(promo?.discount_amount)} 
            />
          </Grid>
        ))}
      </>
    )
  }
}


const Fraud = ({ fraud }) => {
  const translate = useTranslate()
  if (fraud)
    return (
      <>
        <ShowListElement
          sm={2}
          label={translate('ra.field.status_fraud')}
          value={fraud?.Status}
        />
        <ShowListElement
          sm={2}
          label={translate('ra.field.fraud_detail')}
          value={fraud?.Info?.[0]?.Status}
        />
        <ShowListElement
          sm={2}
          label={translate('ra.field.fraud_id')}
          value={fraud?.Info?.[0]?.ID}
        />
        <ShowListElement
          sm={2}
          label={translate('ra.field.emission_status')}
          value={fraud?.Info?.[0]?.StatusClient}
        />
      </>
    )
}


const Traking = ({ tracking }) => {
  const translate = useTranslate()
  if (tracking)
    return (
      <>
        <ShowListElement
          sm={2}
          label={translate('ra.field.session_expired')}
          value={tracking?.session_expired ? translate('ra.message.yes') : translate('ra.message.no')}
        />
        <ShowListElement
          sm={2}
          label={translate('ra.field.session_closed')}
          value={tracking?.session_closed ? translate('ra.message.yes') : translate('ra.message.no')}
        />
        <ShowListElement sm={2} label={translate('ra.field.abandon_instance')} value={tracking?.instance} />
      </>
    )
}

const AdditionalDetails = ({ tracking, fraud, error }) => {
  const translate = useTranslate()

  return (
    <Grid container spacing={2}>
      <Fraud fraud={fraud} />
      <Traking tracking={tracking} />
      {error && <>
        <ShowListElement
          sm={2}
          label={translate('ra.field.error_code')}
          value={error?.code && translate(`ra.status.${error?.code}`)}
        />
        <ShowListElement
          sm={2}
          label={translate('ra.field.error_detail')}
          value={error?.detail}
        />
        </>
      }
    </Grid>
  )
}

const MetaCodeDialog = ({ openMetaDialog, setOpenMetaDialog, meta }) => {
  const translate = useTranslate()
  return (
    <Dialog open={openMetaDialog} onClose={() => setOpenMetaDialog(false)} maxWidth='md' fullWidth={true}>
      <DialogTitle>{translate('ra.field.meta_info')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <ShowListElement
            label={translate('ra.field.source')}
            value={meta?.source}
            sm={6}
          />
          <ShowListElement
            label={translate('ra.field.medium')}
            value={meta?.medium}
            sm={6}
          />
          <ShowListElement
            label={translate('ra.field.campaign')}
            value={meta?.campaign}
            sm={6}
          />
          <ShowListElement
            label={translate('ra.field.sessid')}
            value={meta?.sessid}
            sm={6}
          />
          <ShowListElement
            label={translate('ra.field.tcid')}
            value={meta?.tcid}
            sm={6}
          />
          <ShowListElement
            label={translate('ra.field.term')}
            value={meta?.term}
            sm={6}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export const AirTab = ({ product, loading }) => {
  const translate = useTranslate()
  const [openMetaDialog, setOpenMetaDialog] = useState(false)
  return (
    <>
      <Grid container spacing={2}>
        <ShowListElement
          label={translate('ra.field.device')}
          value={product?.metadata?.device_type}
          sm={2}
        />
        {product?.availability !== undefined && (
          <ShowListElement
            label={translate('ra.field.availability')}
            value={loading ? translate('ra.action.loading') : product?.availability}
            sm={2}
          />
        )}
        {product?.booking && (
          <ShowListElement
            label={translate('ra.field.pnr')}
            value={product?.booking?.bookingNumber}
            sm={2}
          />
        )}
        <Prebooking prebooking={product?.prebooking} />
        <NumPaxes form_passengers={product?.form_passengers} />
        <ShowListElement
          label={translate('ra.field.route_type')}
          value={product?.prebooking?.route_type}
          sm={2}
        />
        {product?.meta && (<Grid item xs={12} sm={2} className='uiShowListElement' onClick={() => setOpenMetaDialog(true)} style={{ cursor: 'pointer' }}>
          <Typography className='keyText' component='div' color='text.primary'>
            {translate('ra.field.meta_code')}
          </Typography>

          <Typography
            className='valueText'
            component='div'
            color='text.primary'
            style={{ overflowWrap: 'break-word' }}
          >
            {loading ? translate('ra.action.loading') : product?.meta?.meta_code}
          </Typography>
        </Grid>)}
        {product?.prebooking?.amountMeta != null && (
          <Grid item xs={12} sm={2} className='uiShowListElement'>
            <Typography className='keyText' component='div' color='text.primary'>
              {translate('ra.field.amount_meta')}
            </Typography>
            <Typography
              className='valueText'
              component='div'
              color='text.primary'
              style={{ overflowWrap: 'break-word' }}
            >
              {loading ? translate('ra.action.loading') : numberFormatterWithDecimalAndThousand(product?.prebooking?.amountMeta)}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} sm={2} className='uiShowListElement'>
          <Typography className='keyText' component='div' color='text.primary'>
            Upsell
          </Typography>
          <Typography
            className='valueText'
            component='div'
            color='text.primary'
            style={{ overflowWrap: 'break-word' }}
          >
            {loading
              ? translate('ra.action.loading')
              : (product?.form_branded_fares?.is_base_fare === true
                ? "Si - " + product?.form_branded_fares?.source
                : "No"
              )}
          </Typography>
        </Grid>
      </Grid>
      <RoundType prebooking={product?.prebooking} />
      <Payment payment={product?.payment} />
      <Promotions promotions={product?.promotions} />

      <AdditionalDetails tracking={product?.tracking} fraud={product?.fraud} error={product?.error} />
      <MetaCodeDialog openMetaDialog={openMetaDialog} setOpenMetaDialog={setOpenMetaDialog} meta={product?.meta} />

       <Card variant="outlined" style={{ marginTop: '20px' }}>
        <CardHeader title={translate('ra.field.customer_info')} />
        <CardContent>
          <Grid container spacing={2}>
            <ShowListElement
              sm={2}
              label={translate('ra.field.name')}
              value={product?.contact?.firstName}
            />
            <ShowListElement
              sm={2}
              label={translate('ra.field.surname')}
              value={product?.contact?.lastName}
            />
            <ShowListElement
              sm={2}
              label={translate('ra.field.country')}
              value={product?.contact?.country}
            />
            <ShowListElement
              sm={2}
              label={translate('ra.field.customer_province')}
              value={product?.contact?.province}
            />
            <ShowListElement
              sm={2}
              label={translate('ra.field.email')}
              value={product?.contact?.emailClient}
            />
            <ShowListElement
              sm={2}
              label={translate('ra.field.city')}
              value={product?.contact?.city}
            />
            <ShowListElement
              sm={2}
              label={translate('ra.field.phone')}
              value={product?.contact?.phoneClient}
            />
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
